import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@page.not_found.title');
    },

    lxBlockText() {
        return Localization.get('badoo_safety_center@page.not_found.text');
    },

    lxBlockCTA() {
        return Localization.get('badoo_safety_center@page.not_found.cta');
    },
};
